import React, { useState, useEffect, useReducer } from 'react';
import './SchoolClasses.css';
import '../Teachers/Teachers.css';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { CardActions } from '@material-ui/core';
import { apiPath, apiKey } from '../../constants';

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
            width: '50ch',
        },
    },
}));

function CourseClasses() {

    let fileReader;
    var userdata = JSON.parse(localStorage.getItem('kokos_userdata'));
    let classArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    let divArray = ['A', 'B', 'C', 'D', 'E', 'F'];

    const [open, setOpen] = useState(false);
    const [openStd, setOpenStd] = useState(false);
    const [sClasses, setsClasses] = useState([]);
    const [teacher, setTeacher] = useState([]);
    const [teachername, setteachername] = useState();
    const [allteachers, setAllteachers] = useState([]);
    const [loading, setLoading] = useState(true);
    // const [classID, setClassID] = useState();
    const [course, setCourse] = useState([]);
    const [checkbox, setCheckbox] = useState(false);
    const [isloading, setIsloading] = useState(true);
    const [courseID, setCourseID] = useState();
    const [popuomsg, setPopupmsg] = useState(false);
    const [message, setMessage] = useState('');
    const [msgstatus, setMsgstatus] = useState();
    const [classname, setClassname] = useState();
    const [newCourseArray, setNewCourseArray] = useState([]);
    const [arrayofCourseCode, setArrayofCourseCode] = useState([]);
    const [arrayofCourses, setArrayofCourses] = useState([]);
    const [assignedData, setAssignedData] = useState([]);
    const [CourseArray, setCourseArray] = useReducer(CourseArrayReducer, []);
    const [classid, setClassid] = useState('');
    const [divisionid, setDivisionid] = useState('');
    const [selectedClassDetails, setSelectedClassDetails] = useState([]);
    const [loadingbtn, setloadingBtn] = useState(false);
    const [classError, setClassError] = useState(false);
    const [divisionError, setDivisionError] = useState(false);


    useEffect(() => {
        initalfetchClassApiCall()
    }, [])

    const initalfetchClassApiCall = () => {
        async function fetchClassData() {
            const response = await fetch(apiPath+'schools/' + userdata.school_code + '/class/list/all', {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'x-api-key': apiKey
                }),
            })
            const result = await response.json();
            setsClasses(result)
            setLoading(false)
        }
        fetchClassData();
        getAllCourses();
    }

    const handleClickOpen = () => {
        setOpen(true);
        var url = apiPath+'users/schools/' + userdata.school_code + '/roles/TCHR'
        fetch(url, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
                'x-api-key': apiKey
            }),
        })
            .then(response => response.json())
            .then(data => {
                setAllteachers(data)
                sortTeacherData(data)
            })
            .catch(error => {
                console.log('There was an error!', error);
            });
    };

    const sortTeacherData = (data) => {
        var techArray = [];
        for (var i = 0; i < data.length; i++) {
            techArray.push(data[i].first_name + ' ' + data[i].last_name)
        }
        setTeacher(techArray);
    }

    const handleClose = (e,reason) => {
        setDivisionError(false)
        //checking reason to avoid closing modal close on backdropclick
        if(!(reason && reason == 'backdropClick')) setOpen(false);
    };

    const handleCourseDetailsOpen = (classDetails) => {
        setOpenStd(true);
        setSelectedClassDetails(classDetails)
        console.log(classDetails)
        setClassid(classDetails.class_name)
        setDivisionid(classDetails.division)
        // setClassID(classCode);
        fetchAssignedClass(classDetails.class_code);
    };

    const handleCourseDetailsClose = () => {
        setOpenStd(false);
        setCheckbox(false);
        setDivisionError(false)
    };

    const fetchAssignedClass = (classCode) => {
        var url = apiPath+'courses/schools/' + userdata.school_code + '/classes/' + classCode + '/enrolments'
        fetch(url, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
                'x-api-key': apiKey
            }),
        })
            .then(response => response.json())
            .then(data => {
                setAssignedData(data)
                compaireCourses(data)
                console.log("assigend data", data)
            })
            .catch(error => {
                console.log('There was an error!', error);
            });
    }

    function CourseArrayReducer(state, action) {
        switch (action.type) {
            case 'add':
                var newArray = [];
                newArray = newCourseArray;
                let aindex = arrayofCourses.findIndex(item => item.course_code === action.course_id);
                newArray[aindex].flag = 1;
                setNewCourseArray(newArray);
                return [...state, newCourseArray];
            case 'remove':
                var newArrayre = [];
                newArrayre = newCourseArray;
                let rindex = arrayofCourses.findIndex(item => item.course_code === action.course_id);
                newArrayre[rindex].flag = 0;
                setNewCourseArray(newArrayre);
                return [...state, newCourseArray];
            default:
                return state;
        }
    }

    const compaireCourses = (data) => {
        var newArray = [];
        if (data.length === 0) {
            for (var i = 0; i < course.length; i++) {
                newArray[i] = { course: course[i], flag: 0, course_code: arrayofCourseCode[i] }
            }
        }
        else {
            for (var j = 0; j < arrayofCourses.length; j++) {
                var courseCode = arrayofCourses[j].course_code;
                if (!!data.find(o => o.course_code === courseCode)) {
                    newArray[j] = { course: course[j], flag: 1, course_code: arrayofCourseCode[j] }
                } else {
                    newArray[j] = { course: course[j], flag: 0, course_code: arrayofCourseCode[j] }
                }
            }
        }
        // console.log(newArray)
        setNewCourseArray(newArray)
    }

    function handleToggleAdd(course_id) {
        setCourseArray({ course_id, type: 'add' })
        setCourseID(course_id);
        checkSubmitButton();
    }

    function handleToggleRemove(course_id) {
        setCourseArray({ course_id, type: 'remove' })
        checkSubmitButton(course_id);
    }

    const checkSubmitButton = (id) => {
        // console.log(newCourseArray);
        var flag = '0';
        for (var i = 0; i < newCourseArray.length; i++) {
            if (newCourseArray[i].flag === '1') {
                setCheckbox(true)
                flag = '1';
                break;
            }
        }
        if (flag === 0) {
            setCheckbox(false)
        }
    }

    const getAllCourses = () => {
        var url = apiPath+'courses/schools/' + userdata.school_code
        fetch(url, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
                'x-api-key': apiKey
            }),
        })
            .then(response => response.json())
            .then(data => {
                setArrayofCourses(data);
                modifyCoursename(data);
            })
            .catch(error => {
                console.log('There was an error!', error);
            });
    }

    const modifyCoursename = (courseDetails) => {
        var modCourseArray = [];
        var courseCodename = [];
        for (var i = 0; i < courseDetails.length; i++) {
            var orgStr = courseDetails[i].course_code;
            var strArray = orgStr.split('+');
            var reCharacter = strArray[1].replace('-', ' ')
            modCourseArray.push(reCharacter)
            courseCodename.push(courseDetails[i].course_code)
        }
        setArrayofCourseCode(courseCodename)
        setCourse(modCourseArray)
    }

    const classes = useStyles();

    const srtingEmptyCheck = (strValue) => {
        return (!strValue.trim().length) ? false : true
    }

    const validateforms = () => {
        var division = document.getElementById("division").value;
        var techerId
        if (teachername === undefined) {
            techerId = allteachers[0].user_id
        } else {
            for (var i = 0; i < allteachers.length; i++) {
                if (allteachers[i].first_name + ' ' + allteachers[i].last_name=== teachername) {
                    techerId = allteachers[i].user_id;
                    break;
                }
            }
        }
        if (classname === undefined) {
            setClassname(classArray[0])
        }
        var classCode = classname + division
        if (classname !== undefined && classCode !== undefined && divisionError === false) {
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': apiKey
                },
                body: JSON.stringify({
                    "class_name": classname,
                    "class_code": classCode,
                    "division": division,
                    "teacher_id": techerId
                })
            };
            fetch(apiPath+'schools/' + userdata.school_code + '/class', requestOptions)
                .then(response => response.json())
                .then(data => {
                    // console.log(data)
                    if (data.status === "success") {
                        togglePopUpOpen(1, data.message)
                    } else {
                        togglePopUpOpen(2, data.message)
                    }
                    initalfetchClassApiCall()
                })
                .catch(error => {
                    console.log('There was an error!', error);
                });
        }
    }

    const changeHandler = (event) => {
        fileReader = new FileReader();
        fileReader.onloadend = handleFileRead;
        fileReader.readAsText(event.target.files[0])
    }

    const handleFileRead = (e) => {
        const content = fileReader.result;
        csvJSON(content)
    }

    const csvJSON = (csv) => {
        const lines = csv.split('\n')
        const result = []
        const headers = lines[0].split(',')

        for (let i = 1; i < lines.length; i++) {
            if (!lines[i])
                continue
            const obj = {}
            const currentline = lines[i].split(',')

            for (let j = 0; j < headers.length; j++) {
                obj[headers[j]] = currentline[j]
            }
            result.push(obj)
        }
        // console.log(result)
        uploadCsvFunction(result)
    }

    const uploadCsvFunction = (data) => {
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': apiKey
            },
            body: JSON.stringify(data)
        };
        fetch(apiPath+'users/schools/' + userdata.school_code + '/csv', requestOptions)
            .then(response => response.json())
            .then(data => {
                // console.log(data)
            })
            .catch(error => {
                console.log('There was an error!', error);
            });
    }


    const togglePopUpOpen = (status, data) => {
        handleClose()
        setMsgstatus(status);
        setMessage(data);
        setPopupmsg(true)
    }

    const togglePopUpClose = () => {
        setPopupmsg(false)
    }

    const editClassDetailsApicall = () => {
        if (!classError && !divisionError) {
            setloadingBtn(true)
            var selectedCourse = {}
            var removedCourseArray = {}
            for (var i = 0; i < newCourseArray.length; i++) {
                if (newCourseArray[i].flag === 1) {
                    selectedCourse[i] = newCourseArray[i].course_code
                } else {
                    removedCourseArray[i] = newCourseArray[i].course_code
                }
            }

            console.log(selectedCourse, removedCourseArray)
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': apiKey
                },
                body: JSON.stringify({
                    "class_name": classid,
                    "division": divisionid,
                    "class_code": selectedClassDetails.class_code,
                    "enrolled_status": "1",
                    "unenrolled_status": "0",
                    "enrolled_course_code": selectedCourse,
                    "unenrolled_course_code": removedCourseArray
                })
            };
            fetch(apiPath+'courses/schools/' + userdata.school_code + '/courses/enrolments/class/v2', requestOptions)
                .then(response => response.json())
                .then(data => {
                    console.log(data)
                    if (data.status === "success") {
                        togglePopUpOpen(1, data.message)
                    } else {
                        togglePopUpOpen(2, data.message)
                    }
                    setloadingBtn(false)
                    setOpenStd(false);
                    initalfetchClassApiCall();
                })
                .catch(error => {
                    console.log('There was an error!', error);
                });
        }
    }

    const validateClass = () => {
        var hasNumber = /\d/;
        if (classid.length !== 0 && hasNumber.test(classid) === true) {
            setClassError(false);
        } else {
            setClassError(true);
        }
    }

    const validateDivision = (divisionName) => {
        var hasNumber = /\d/;
        if (divisionName.length !== 0 && hasNumber.test(divisionName) === false) {
            setDivisionError(false);
        } else {
            setDivisionError(true);
        }
    }

    return (
        <div className="CourseClassesmain">
            <div className="classes_buttonmain" onClick={handleClickOpen}>
                Add New Class
            </div>
            {
                loading ?
                    <img className="loadingSymbol" src={require('../../images/loading2.gif')} alt="loading" />
                    :
                    <div className="fixTableHead">
                        <table>
                            <thead>
                                <tr>
                                    <th>Class</th>
                                    <th>Division</th>
                                    <th>Teacher</th>
                                    <th>Update Class</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    sClasses && sClasses.map((classdetails, index) => {
                                        return (
                                            <tr key={classdetails.class_id}>
                                                <td>{classdetails.class_name}</td>
                                                <td>{classdetails.division}</td>
                                                <td>{classdetails.teacher + ' ' + classdetails.teacher_lastname}</td>
                                                <td><div className="CourseCls_assign"
                                                    onClick={() => handleCourseDetailsOpen(classdetails)}
                                                >Edit Class</div></td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
            }

            <div>
                <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
                    <DialogTitle id="customized-dialog-title" onClose={handleClose}>Class Details</DialogTitle>
                    <DialogContent dividers>
                        <form style={{ padding: '0vw 4vw', width: '35vw' }}>
                            <div className="class_techer_select">
                                <div className="class_techer_select_heading">Select class</div>
                                <select className="class_techer_dropdown"
                                    value={classname}
                                    onChange={e => setClassname(e.target.value)}
                                    onBlur={e => setClassname(e.target.value)}
                                >
                                    {
                                        classArray.map((classnames, index) => {
                                            return (
                                                <option key={index} value={classnames}>
                                                    {classnames}
                                                </option>
                                            );
                                        })
                                    }
                                </select>
                            </div>
                            <div className="class_name" id='class_error'></div>
                            <input id="division" className="input_division" type="text" placeholder="Division" onBlur={e => validateDivision(e.target.value)}/>
                            {divisionError && <div className="emailwarningmessage" id='division_error'>*Please enter valid divison</div>}
                            <div className="class_techer_select">
                                <div className="class_techer_select_heading">Select class Teacher</div>
                                <select className="class_techer_dropdown"
                                    value={teachername}
                                    onChange={e => setteachername(e.target.value)}
                                    onBlur={e => setteachername(e.target.value)}>
                                    {
                                        teacher && teacher.map((teachernames, index) => {
                                            return (
                                                <option key={index} value={teachernames}>
                                                    {teachernames}
                                                </option>
                                            );
                                        })}
                                </select>
                            </div>
                            {
                                // <div className="student_or">OR</div>
                                // <div className="fileUpload_Std Student_button_new">
                                //     <span>Load From csv</span>
                                //     <input id="uploadfile" type="file" className="upload" accept='.csv' />
                                // </div>
                            }
                            {
                                // <input className="input_courses" type="text" placeholder="Move students from" />
                            }
                        </form>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={validateforms} color="primary">
                            create
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
            <div className={`addCoursesModalBackground addCoursesmodalShowing-${openStd}`}>
                <div className="editmodal_close_img_div">
                    <img onClick={handleCourseDetailsClose} className="editmodal_close" src={require('../../images/close.png')} />
                </div>
                <div className="editTeacherHeading">Edit Class Details</div>
                <div className="cls-editModalBackground_outter">
                <div className="cls-modalTeacherName">Teacher Name : {selectedClassDetails.teacher}</div>
                    <form autoComplete="off" className="cls-edit_input_outter">
                        <div className="classpage_placeholder">
                            <div className="std_firstname_style">Class :</div>
                            <input className="cls-edit_input_teachers" type="text" onBlur={e => validateClass(e.target.value)}
                                value={classid} onChange={e => setClassid(e.target.value)}
                            />
                            {classError && <div className="emailwarningmessage">*Please enter valid class</div>}
                        </div>
                        <div className="classpage_placeholder">
                            <div className="std_firstname_style">Division :</div>
                            <input className="cls-edit_input_teachers" type="text" onBlur={e => validateDivision(e.target.value)}
                                value={divisionid} onChange={e => setDivisionid(e.target.value)}
                            />
                            {divisionError && <div className="emailwarningmessage">*Please enter valid division</div>}
                        </div>
                        <div className="edit_coursedetails_outter">
                            <div className="edit_coursedetails_heading">Courses</div>
                            <div className="cls-edit_coursedetails_names">
                                {
                                    newCourseArray && newCourseArray.map((coursedetails, index) => {
                                        return (
                                            <div className="edit_coursedetails_checkboxmain" key={index}>
                                                {
                                                    (coursedetails.flag === 1) &&
                                                    <img className="cls-edit_coursedetails_checkbox"
                                                        onClick={() => handleToggleRemove(coursedetails.course_code)}
                                                        src={require('../../images/tick.png')} alt="checked" />
                                                }
                                                {
                                                    (coursedetails.flag === 0) &&
                                                    <img className="cls-edit_coursedetails_checkbox"
                                                        onClick={() => handleToggleAdd(coursedetails.course_code)}
                                                        src={require('../../images/untick.png')} alt="unchecked" />
                                                }
                                                <div className="edit_coursedetails_coursename">
                                                    {
                                                        coursedetails.course
                                                    }
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </form>
                </div>
                <div className="cls-edit_resetpassword_outter">
                    {loadingbtn ? <div className="edit_resetpassword_btn_class"><div className="loader"></div></div> :
                        <div className="cls-edit_resetpassword_btn" onClick={() => editClassDetailsApicall()}>Update</div>}
                </div>
            </div>
            <div className={`popUpModalBackground popUpmodalShowing-${popuomsg}`}>
                {
                    (msgstatus && msgstatus === 1) ?
                        <div>
                            <div className="popUpModal-success">
                                <img className="popUpModal-successimg" src={require('../../images/success.png')} />
                            </div>
                            <div className="popUpModal-Content">
                                {message}
                                <div className="popUpModal-submitOutter">
                                    <div className="popUpModal-submitInner" onClick={() => togglePopUpClose()}>close</div>
                                </div>
                            </div>
                        </div>
                        :
                        <div>
                            <div className="popUpModal-success">
                                <img className="popUpModal-successimg" src={require('../../images/warning.png')} />
                            </div>
                            <div className="popUpModal-Content">
                                {message}
                                <div className="popUpModal-submitOutter">
                                    <div className="popUpModal-submitInner" onClick={() => togglePopUpClose()}>close</div>
                                </div>
                            </div>
                        </div>
                }
            </div>
        </div>
    );

}

export default CourseClasses;